import { escapeAttr, escapeHtml } from "@emkit/builder-core";
export const QUOTE_DEFAULTS = {
    quote: "Simplicity is the ultimate sophistication. A builder should get out of your way.",
    author: "Leonardo da Vinci",
    source: "Notebooks",
    avatarUrl: "",
    style: "modern",
    align: "center",
    accent: "#111827",
    background: "transparent",
    textColor: "#0f172a",
};
export const quoteWidget = {
    type: "quote",
    defaultProps: QUOTE_DEFAULTS,
    renderHtml(props, ctx) {
        const style = props.style ?? "modern";
        const align = props.align ?? "center";
        const accent = props.accent ?? "#111827";
        const bg = props.background ?? "transparent";
        const text = props.textColor ?? "#0f172a";
        const avatar = props.avatarUrl
            ? `<img src="${escapeAttr(ctx.resolveAssetUrl?.(props.avatarUrl) ?? props.avatarUrl)}" alt="" loading="lazy" decoding="async" style="width:48px;height:48px;border-radius:50%;object-fit:cover;margin:${align === "center" ? "0 auto 12px" : "0 0 12px 0"};display:block">`
            : "";
        const citation = props.author || props.source
            ? `<figcaption style="margin-top:16px;font-size:14px;opacity:0.7">${props.author ? `<strong style="font-weight:600">${escapeHtml(props.author)}</strong>` : ""}${props.author && props.source ? " · " : ""}${props.source ? `<cite style="font-style:italic">${escapeHtml(props.source)}</cite>` : ""}</figcaption>`
            : "";
        if (style === "classic") {
            return `<figure class="emk-quote emk-quote--classic" style="margin:0;padding:8px 20px;border-left:4px solid ${accent};background:${bg};color:${text};font-family:inherit;text-align:${align === "center" ? "center" : "left"}"><blockquote style="margin:0;font-size:20px;line-height:1.5;font-style:italic">"${escapeHtml(props.quote)}"</blockquote>${citation}</figure>`;
        }
        if (style === "card") {
            return `<figure class="emk-quote emk-quote--card" style="margin:0;padding:32px;background:${bg === "transparent" ? "#ffffff" : bg};color:${text};border:1px solid rgba(0,0,0,0.08);border-radius:12px;font-family:inherit;text-align:${align === "center" ? "center" : "left"};max-width:720px;margin:0 auto"><div aria-hidden="true" style="font-size:36px;line-height:1;color:${accent};margin-bottom:12px;${align === "center" ? "text-align:center" : ""}">"</div>${avatar}<blockquote style="margin:0;font-size:20px;line-height:1.55;font-weight:500">${escapeHtml(props.quote)}</blockquote>${citation}</figure>`;
        }
        return `<figure class="emk-quote emk-quote--modern" style="margin:0;padding:24px;background:${bg};color:${text};font-family:inherit;text-align:${align === "center" ? "center" : "left"};max-width:720px;margin:0 auto">${avatar}<blockquote style="margin:0;font-size:24px;line-height:1.5;font-weight:500;letter-spacing:-0.01em">"${escapeHtml(props.quote)}"</blockquote>${citation}</figure>`;
    },
};
//# sourceMappingURL=quote.js.map